// react
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

// components
import { BUTTON_THEME, CircularLoader } from '@st-operations/uikit/src/v2/index.js'
import TaxonomyForm from './form'

// lib
import { logErrorAsync } from '_lib/utility'
import User from '_lib/User'

// Styles
import './styles.scss'

// local
import { FIELDS, INITIAL_STATE } from './constants'
import { get } from '_services/requests'

const ENTITY = 'taxonomies'

const getTaxonomy = ({ id }) => get(['taxonomies', id], { transformPayload: false })

const EditTaxonomy = (props) => {
  const { id } = props.match.params

  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const [needMappingIds, setNeedMappingIds] = useState(null)
  const [distributions, setDistributions] = useState([])
  const [values, setValues] = useState(INITIAL_STATE)

  const [hasChanges, setHasChanges] = useState(false)

  const loadTaxonomy = (id) => {
    getTaxonomy({ id })
      .then((data) => {
        setData(data)
        setDistributions(data.distribution)
      })
      .catch((error) => {
        logErrorAsync(error)
        toast.error(error.message)
      })
  }

  useEffect(() => {
    User.watch(this, (user) => {
      if (user) {
        loadTaxonomy(id)
      }
    })
  }, [id])

  useEffect(() => {
    if (data) {
      setValues((initialState) => {
        const newObject = JSON.parse(JSON.stringify(initialState))
        for (const key in initialState) {
          if (data.hasOwnProperty(key)) {
            newObject[key] = data[key]
          }
        }
        return newObject
      })
    }
  }, [data])

  const handleExit = () => {
    props.history.push(`/${ENTITY}`)
  }

  const handleChange = (field, value) => {
    setValues((v) => ({ ...v, [field.name]: value }))
    setHasChanges(true)
  }

  const handleSave = () => {
    const requestBody = {
      name: values.name,
      slug: values.slug,
      is_branded: values.is_branded,
      distribution: values.distribution,
    }
    if (values.segments.length > 0) {
      const { segments, name_separator, id_sets } = values
      requestBody.new_segments_config = {
        segments,
        name_separator,
        id_sets,
      }
    }
    window._api.put(`/taxonomies/${id}`, requestBody, (error) => {
      if (error) {
        toast.error(error.message)
      } else {
        toast.success('Update successful!')
        setHasChanges(false)
        window.location.reload()
      }
    })
  }

  const headerActions = [
    {
      children: 'Exit',
      onClick: handleExit,
      theme: BUTTON_THEME.GHOST,
    },
    {
      children: 'Save',
      onClick: handleSave,
      disabled: !hasChanges,
    },
  ]

  if (error) {
    return (
      <div id="taxonomy-page">
        <p>{error.message}</p>
      </div>
    )
  }

  if (!data) {
    return (
      <div className="taxonomy-loading">
        <CircularLoader />
      </div>
    )
  }

  return (
    <div id="taxonomy-page" className="taxonomy">
      {/* API integrations get their own page rather than another section
          here - the push list, the form and a results table running to
          thousands of rows are too much for a page already carrying the
          taxonomy form and its distributions. Same split as audiences. */}
      <If condition={data.slug}>
        <div className="flex gap-4 mb-4 text-sm">
          <Link to={`/taxonomies/${data.slug}/audiences`}>Audiences</Link>
          <Link to={`/taxonomies/${data.slug}/api-integrations`}>API Integrations</Link>
        </div>
      </If>
      <TaxonomyForm
        handleChange={handleChange}
        headerActions={headerActions}
        distributions={distributions}
        taxonomyId={id}
        title={data.name}
        fields={FIELDS}
        values={values}
        setError={setError}
        setNeedMappingIds={setNeedMappingIds}
        needMappingIds={needMappingIds}
      />
    </div>
  )
}

export default EditTaxonomy
